import useCommonCustomerQueryCaa from "@repo/shopifyV2/queries/useCustomerQueryCaa";

import { caaRequest } from "@lib/caaClient";

export default function useCustomerCaa() {
  return useCommonCustomerQueryCaa({ request: caaRequest });
}
